<script lang="ts">
  import Icon from '$components/elements/Icon.svelte';
  import Modal from '$components/elements/Modal.svelte';
  import ModalImageHeader from '$components/elements/ModalImageHeader.svelte';
  import Flex from '$components/layout/Flex.svelte';
  import Grid from '$components/layout/Grid.svelte';
  import Desktop from '$components/utils/Desktop.svelte';
  import { currentUser } from '$lib/client/pocketbase';
  import { getMyDonations } from '$lib/client/pocketbase/donations';

  export let show = false;

  export let onClose: () => void = () => {
    show = false;
  };
</script>

<Modal showModal={show} overlayOnMobile={true} width="1024px">
  <div class="dashboard">
    <Desktop>
      <div class="dashboard__closer">
        <Icon icon="cross" on:click={onClose} cursor="pointer" casing="30px" />
      </div>
    </Desktop>
    <ModalImageHeader>
      <h1>
        <span>{$currentUser?.name} {$currentUser?.surname}</span><br />Moje příspěvky a potvrzení
      </h1>
    </ModalImageHeader>
    <Grid
      breakpoints={{
        0: {
          templateColumns: '1fr',
          margin: '37px 16px',
          width: 'calc(100% - 32px)'
        },
        720: {
          templateColumns: '1fr',
          gap: {
            column: '36px',
            row: '30px'
          },
          margin: '37px 90px',
          width: 'calc(100% - 180px)',
          alignItems: 'start'
        }
      }}
    >
      <div class="dashboard__section">
        <div class="dashboard__section__header">
          <Icon icon="shopping-cart" color="#C99E77" />
          Moje příspěvky
        </div>
        <div class="dashboard__section__content">
          <Flex direction="row" gap="24px" width="100%" wrap="wrap" justifyContent="flex-start">
            {#await getMyDonations() then donations}
              {#each donations
                ?.map((donation) => ({ ...donation, date: new Date(donation.date) }))
                ?.sort((a, b) => b.date.getTime() - a.date.getTime()) ?? [] as donation}
                <div class="donation-card">
                  <span class="donation-card__date"
                    >{donation.date.toLocaleString(undefined, {
                      year: 'numeric',
                      month: 'long',
                      day: 'numeric'
                    })}</span
                  >
                  <span class="donation-card__amount"
                    >{donation.amount.toLocaleString(undefined, {
                      style: 'currency',
                      currency: 'CZK',
                      useGrouping: true,
                      maximumFractionDigits: 0
                    })}</span
                  >
                </div>
              {/each}
            {/await}
          </Flex>
        </div>
      </div>
    </Grid>
  </div>
</Modal>

<style lang="scss">
  .dashboard {
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
    height: 100%;
    padding-bottom: 60px;
    position: relative;

    h1 {
      font-weight: 700;
      font-size: 28px;
      line-height: 38px;
      text-align: center;

      span {
        color: $color-caramel;
      }
    }

    &__closer {
      position: absolute;
      top: 20px;
      right: 25px;
    }

    &__section {
      width: 100%;

      &__header {
        display: flex;
        align-items: center;
        gap: 9px;
        border-bottom: 1.5px solid $color-medium-gray;
        padding-bottom: 6px;
        color: $color-caramel;
        font-size: 14px;
      }

      &__content {
        display: flex;
        flex-direction: column;
        gap: 22px;
        padding: 16px 0;
      }
    }
  }

  @include mobile {
    .dashboard {
      &__section {
        &__content {
          align-items: center;
        }
      }
    }
  }

  .donation-card {
    width: 200px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    border: 2px solid $color-dark-gray;
    border-radius: 25px;
    padding: 8px 16px 24px 16px;
    gap: 8px;
    &__date {
      font-size: 14px;
      color: $color-dark-gray;
      align-self: flex-end;
    }
    &__amount {
      font-size: 20px;
      color: $color-dark-gray;
      font-weight: bold;
    }
  }
</style>
